import { error, finish } from '../../../modules/market-templates/actions/get-list';
import api from '../../../api';

export function request(dispatch, { sportId, data }) {
    $appState.sdkStaff.getMarketTemplates(sportId).then((response) => {
        dispatch(finish(sportId, response.results));
    }).catch((error) => {
        console.error('getMarketTemplates error', error);
    });

    // api.get(`/sports/${sportId}/market-templates`, void 0, {
    //     cache: 1000,
    //     headers: {
    //         'Cache-Control': data && data.cache ? 'public,max-age=3600' : 'no-cache, must-revalidate'
    //     }
    // }).then(
    //     data => dispatch(finish(sportId, data)),
    //     errors => dispatch(error(sportId, errors))
    // );
}
